import { feathersClient } from './index';

export const Users = feathersClient.service('users');
export const UserProfile = feathersClient.service('user-profile');
export const ChangePassword = feathersClient.service('change-password');
export const ResetPassword = feathersClient.service('reset-password');
export const OtpLogin = feathersClient.service('otp-login');
export const PropertyCategory = feathersClient.service('property-category');
export const PropertySubCategory = feathersClient.service('property-sub-category');
export const LocationManagement = feathersClient.service('location-management');
export const AdvertisePackage = feathersClient.service('advertise-package');
export const PropertyFeature = feathersClient.service('property-feature');
export const PropertyFacility = feathersClient.service('property-facility')
export const Advertise = feathersClient.service('advertise');
export const ChangeAdvertiseStatus = feathersClient.service('change-advertise-status');
export const BulkChangeAdvertiseStatus = feathersClient.service('bulk-change-advertise-status');
export const CompanyAdvertiseBulkStatus = feathersClient.service('company-advertise-bulk-status');
export const ChangeUserProfileStatus = feathersClient.service('change-user-profile-status');
export const Settings = feathersClient.service('settings');
export const RegistrationRejectionReasons = feathersClient.service(
  'registration-rejection-reasons'
);
export const ContactForm = feathersClient.service('contact-form');
export const PushNotificationManagement = feathersClient.service('push-notification-management');
export const DashboardReport = feathersClient.service('dashboard-reports');
export const Payment = feathersClient.service('payment');
export const PossessionType = feathersClient.service('property-possession-type');
export const LocationCoordinate = feathersClient.service('get-location-coordinate');
export const ChangeAdvertiseMediaPosition = feathersClient.service('change-advertise-media-position');

// KPI Services
export const AdPublishingStats = feathersClient.service('kpi/ad-publishing-stats');
export const UserRegistrationStats = feathersClient.service('kpi/user-registrations');
export const AdvertiserPerformanceStats = feathersClient.service('kpi/advertisers/performance');

// Agent Management Service
export const AgentManagement = feathersClient.service('agent-management');

// Company Licenses Service
export const CompanyLicenses = feathersClient.service('company-licenses');

// Notification Service
export const Notification = feathersClient.service('notification');

// Company License Renewals Service
export const CompanyLicenseRenewals = feathersClient.service('company-license-renewals');

// Broker Licenses Service
export const BrokerLicenses = feathersClient.service('broker-licenses');

// Broker License Renewals Service
export const BrokerLicenseRenewals = feathersClient.service('broker-license-renewals');

// Companies List Service
export const CompaniesList = feathersClient.service('companies-list');

// Brokers List Service
export const BrokersList = feathersClient.service('brokers-list');

// Agent Management List Service (for dropdowns)
export const AgentManagementList = feathersClient.service('agent-management/list');

// Wishlist Analyzer Service
export const WishlistAnalyzer = feathersClient.service('wishlist-analyzer');

// Account Type Conversion Service
export const AccountTypeConversion = feathersClient.service('account-type-conversion');

// Agent Deactivation Transfer Service
export const AgentDeactivationTransfer = feathersClient.service('agent-deactivation-transfer');

// Agent Ad Transfer Log Service
export const AgentAdTransferLog = feathersClient.service('agent-ad-transfer-log');